import type { QuizStep } from '../../types';
import { cn } from '@/lib/utils';

interface Props {
  step: QuizStep;
  value: string[];
  onChange: (value: string[]) => void;
}

export function MultipleChoiceStep({ step, value, onChange }: Props) {
  const toggle = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  return (
    <div className="space-y-3">
      {step.options?.map((option) => {
        const checked = value.includes(option.value);
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => toggle(option.value)}
            className={cn(
              'flex w-full items-center rounded-xl border-2 px-4 py-3.5 text-left text-[15px] font-medium transition-all',
              checked
                ? 'border-primary bg-primary/5 text-foreground'
                : 'border-border bg-card text-foreground hover:border-primary/40',
            )}
          >
            <span
              className={cn(
                'mr-3 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 transition-colors',
                checked
                  ? 'border-primary bg-primary'
                  : 'border-muted-foreground/30',
              )}
            >
              {checked && (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="text-primary-foreground">
                  <path d="M2.5 6L5 8.5L9.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </span>
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
